import { CmdSymbol } from 'components/search/CmdSymbol';
import { getOS } from 'helpers/os';

const OsCmdSymbol = () => {
    const os = getOS();
    switch (os) {
        case 'mac':
        case 'ios':
            return <CmdSymbol>&#8984;</CmdSymbol>;
        case 'windows':
            return <CmdSymbol>&#8997;</CmdSymbol>;
        case 'linux':
        case 'android':
        default:
            return <CmdSymbol className={'w-9'}>Ctrl</CmdSymbol>;
    }
};

export { OsCmdSymbol };
